import React, { useEffect, useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { setError, selectError } from '../features/error/errorSlice';
import styled from 'styled-components';
import { wh, fontSize } from '../mixins';


const isArabic = navigator.language.startsWith('ar');
const textAlign = isArabic ? 'right' : 'left';

const StyledAlert = styled.div`
  ${wh('90%', 'auto')};
  max-width: 327px;
  min-height: 50px;
  padding: 16px 40px 16px 16px;
  border-radius: 8px;
  background-color: #FF5B5B;
  position: absolute;
  left: 50%;
  top: 6%;
  transform: translate(-50%, -20%);
  ${fontSize(14)};
  line-height: 18px;
  color: #fff;
  text-align: ${textAlign};
  z-index: 100;
  ${({ show }) => (show
    ? `
      opacity: 1;
      visibility: visible; 
    `
    : `
      opacity: 0;
      visibility: hidden;
    `
  )};
  transition: 150ms ease;
`;

const CloseAlert = styled.div`
  content: '×';
  display: block;
  ${wh('24px')};
  position: absolute;
  top: 50%;
  right: 16px;
  margin-top: -12px;
  color: #fff;
  line-height: 24px;
  ${fontSize(24)};
  text-align: center;
  cursor: pointer;
`;

const UIAlert = () => {
  const { t } = useTranslation();
  const error = useSelector(selectError);
  const dispatch = useDispatch();
  const [clear,setClear] = useState(false);

  const clearError = useCallback(
    () => dispatch(setError({ show: false, text: '', type: '' })),
    [dispatch]
  );

  const doesEmailExist =
    error &&
    error.text &&
    (typeof error.text === 'string') &&
    (
      error.text.replace('.','').toLowerCase() === 'the email has already been taken' ||
      error.text === 'exception.userEmailTaken'
    );

  useEffect(() => {
    if (error.show && !clear) {
      var timer = setTimeout(clearError, 3000);
    }
    return () => {
      setClear(false);
      clearTimeout(timer);
    }
  }, [error, clearError, clear]);

  const onCloseClick = () => {
    setClear(true);
    clearError()
  };

  return (
    <StyledAlert show={error.show}>
      <p>{doesEmailExist ? t('email_exist') : error.text}</p>
      {error.show && <CloseAlert onClick={onCloseClick}>×</CloseAlert>}
    </StyledAlert>
  )
};

export default UIAlert;